import React from 'react';
import MaterialIcon from '@/components/MaterialIcon';

/**
 * RegisterHeroSection組件
 * 注册页面英雄区域
 *
 * 显示14日間無料トライアル主标题
 */
export const RegisterHeroSection: React.FC = () => {
  return (
    <div className="w-full px-4 md:px-10 lg:px-40 py-12 md:py-16 bg-gradient-to-br from-solution-orange/5 to-orange-50">
      <div className="max-w-[1200px] w-full mx-auto text-center">
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-solution-orange/10 text-solution-orange text-sm font-bold mb-6">
          <MaterialIcon name="rocket_launch" className="text-lg" />
          14日間無料トライアル
        </span>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-solution-text mb-4">無料で始める</h1>
        <p className="text-lg text-solution-text-secondary max-w-2xl mx-auto">
          クレジットカード不要。最短1週間で導入。
          <br />
          GBase SupportのAIコンシェルジュを今すぐ体験してください。
        </p>
      </div>
    </div>
  );
};

export default RegisterHeroSection;
